import { useState } from 'react';
import { CallTrackingView, GrowthDashboardTopBarActions } from '@elva/ui';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useCallTracking, useCallTrackingMutations } from '../hooks/useCallTracking';

export function CallTrackingPage() {
  const [page, setPage] = useState(1);

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useCallTracking(page);
  const { exportCsv } = useCallTrackingMutations();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
      isEmpty={data !== undefined && data.items.length === 0 && page === 1}
    >
      <CallTrackingView
        {...viewProps({
          items: data?.items,
          stats: data?.stats,
          attribution: data?.attribution,
          numberPool: data?.numberPool,
          pagination: data?.pagination,
          loading: isFetching || exportCsv.isPending,
          onPageChange: setPage,
          onExportCsv: () => exportCsv.mutate(),
          exportLoading: exportCsv.isPending,
        })}
      />
    </AsyncBoundary>
  );
}
